import { Action, combineReducers, createStore, applyMiddleware, compose } from "@reduxjs/toolkit";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { TActionProps, TimelineActionTypes } from "./TimelineActions";
import { TimelineReducer } from "./TimelineReducer";

const TimelineRootReducer = combineReducers({
	Timeline: TimelineReducer,
});

export type TimelineRootState = ReturnType<typeof TimelineRootReducer>;
export interface DispatchAction<T, P> extends Action<T> {
	payload: P;
}

const middleware = thunk as ThunkMiddleware<TimelineRootState, DispatchAction<TimelineActionTypes, TActionProps>>;

export const TimelineStore = createStore(TimelineRootReducer, compose(applyMiddleware(middleware)));
